var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 118,
    viewBox: "0 0 212 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_641)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.617 40.8293C181.889 18.1847 163.289 0.0527344 140.449 0.0527344C129.85 0.0527344 120.164 3.95712 112.751 10.4107C104.162 5.33682 94.1433 2.41414 83.4425 2.41414C53.4136 2.41414 28.7525 25.3547 26.0421 54.6488C11.2369 57.349 0.015625 70.301 0.015625 85.8736C0.015625 103.404 14.2371 117.613 31.7834 117.613H169.482V117.439C170.694 117.554 171.925 117.613 173.168 117.613C194.71 117.613 212.171 100.169 212.171 78.6445C212.171 60.3757 199.594 45.0501 182.617 40.8293Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6111 57.3836C89.2682 56.7611 89.2886 56.0529 89.6621 55.4549L104.48 31.8449C104.841 31.2776 105.416 30.9551 106.092 30.9551C106.766 30.9551 107.347 31.2776 107.704 31.8449L122.522 55.4549C122.895 56.0529 122.916 56.7611 122.573 57.3836C122.228 58.0061 121.622 58.3674 120.909 58.3674H114.205V77.0586C114.205 78.1056 113.352 78.9588 112.303 78.9588H99.8793C98.8322 78.9588 97.9791 78.1056 97.9791 77.0586V58.3674H91.2786C90.5622 58.3633 89.956 58.0021 89.6111 57.3836ZM129.349 75.7157C126.153 75.7157 123.565 78.3016 123.565 81.4937V84.5123H88.6151V81.4937C88.6151 78.3057 86.0251 75.7157 82.831 75.7157C79.641 75.7157 77.0469 78.3016 77.0469 81.4937V90.2862C77.0469 93.4742 79.641 96.0601 82.831 96.0601H129.345C132.535 96.0601 135.127 93.4742 135.127 90.2862V81.4937C135.131 78.3016 132.543 75.7157 129.349 75.7157Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 117.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.e44c8b0dcf3518857166926cf78b18d5.svg";
export { ForwardRef as ReactComponent };